import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RoutePaths } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import CloseIcon from '@assets/icons/close.svg';
import ArrowIcon from '@assets/icons/arrow.svg';

interface PropsType {
  isOpen: boolean;
  onClose?: () => void;
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  url?: string;
  buttonTitle?: ReactNode;
  onClick?: () => void;
}

export const ConfirmModal = (props: PropsType) => {
  const { t } = useTranslation('payments');

  if (!props.isOpen) return;
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='relative flex h-full max-h-80 w-full max-w-[556px] flex-col items-center justify-center bg-ice p-14 shadow-lg dark:bg-eerie-black'>
        {props.onClose && (
          <Button className='absolute right-[24px] top-[24px]' color='icon' onClick={props.onClose}>
            <Icon icon={<CloseIcon />} />
          </Button>
        )}
        <Icon icon={props.icon} className='mb-6 flex justify-center' color='primary' />
        <Text className='mb-6 whitespace-pre-line' center weight='semibold' size='2xl'>
          {props.title}
        </Text>
        {props.description && (
          <Text className='mb-4' center>
            {props.description}
          </Text>
        )}
        <div className='flex justify-center'>
          <Button color='outlined' to={!props.onClick ? props.url || RoutePaths.payments.onNavigate() : undefined} onClick={props.onClick}>
            {props.buttonTitle || t('modals.confirm.buttons.back')} <Icon icon={<ArrowIcon />} color='inherit' />
          </Button>
        </div>
      </div>
    </div>
  );
};
